export default __webpack_public_path__ + "static/media/wildCodeSchool.f61059b3.png";